var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-3",attrs:{"header":"Codles em falta"}},[_c('grid-local',{attrs:{"name":'missingCodleGrid',"url":_vm.url,"columns":_vm.columns,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a99e342","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/tables/missingcodles.vue
// module id = 984
// module chunks = 1